module.exports = __webpack_public_path__ + "static/img/widget-6.7c7e8be6.png";